import { useMutation } from "@tanstack/react-query";
import { api } from "./api";
import type { Athlete } from "./auth";

export type TgLinkStart = { token: string; deeplink: string };
export type TgLinkStatus = { confirmed: boolean };

export function useTgLinkStart() {
  return useMutation({
    mutationFn: async () => {
      const r = await api.post<TgLinkStart>("/athlete/auth/tg-link/start");
      return r.data;
    },
  });
}

export async function pollTgLinkStatus(token: string): Promise<TgLinkStatus> {
  const r = await api.get<TgLinkStatus>("/athlete/auth/tg-link/status", {
    params: { token },
  });
  return r.data;
}

export function useTgLinkConsume() {
  return useMutation({
    mutationFn: async (token: string) => {
      const r = await api.post<Athlete>("/athlete/auth/tg-link/consume", { token });
      return r.data;
    },
  });
}
